<template lang="pug">
#attachments-tab
  b-field(label="Collections")
    elasticsearch-multiselect(
      field="title"
      index="doxa_episode_collections"
      :value="event.collection_ids"
      @input="set($event, 'collection_ids')"
    )
  b-field(label="Events")
    elasticsearch-multiselect(
      field="title"
      index="doxa_events"
      :value="event.event_ids"
      @input="set($event, 'event_ids')"
    )
  b-field(label="Ministries")
    elasticsearch-multiselect(
      field="name"
      index="doxa_ministries"
      :value="event.ministry_ids"
      @input="set($event, 'ministry_ids')"
    )
</template>

<script>
import { mapGetters } from 'vuex';
import ElasticsearchMultiselect from '@/components/form/ElasticsearchMultiselect';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'attachments-tab',
  components: {
    ElasticsearchMultiselect,
  },
  computed: {
    ...mapGetters({
      event: getters.GET_EVENT,
    }),
  },
  methods: {
    set(val, key) {
      this.$store.commit(mutations.SET_EVENT_FIELD, {
        key,
        val,
      });
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/form/event/AttachmentsTab.vue